"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgCloud9 = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_CLOUD9", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "m6.527 9.272 1.892.598c-.29 1.051-.774 1.833-1.45 2.346-.673.508-1.528.762-2.565.762-1.284 0-2.338-.436-3.165-1.308C.413 10.794 0 9.598 0 8.082 0 6.48.415 5.235 1.246 4.35c.83-.89 1.923-1.334 3.276-1.334 1.183 0 2.143.348 2.881 1.044.44.412.77 1.004.99 1.775l-1.932.46c-.115-.5-.354-.894-.719-1.183-.36-.29-.8-.434-1.318-.434-.717 0-1.3.256-1.747.769-.444.513-.666 1.343-.666 2.49 0 1.218.22 2.086.659 2.603.44.517 1.01.775 1.714.775.519 0 .965-.164 1.338-.493.374-.328.642-.845.805-1.55ZM9.73 10.586l1.794-.197c.044.363.158.633.343.808.184.175.428.263.731.263.383 0 .708-.175.976-.526.268-.35.44-1.078.514-2.182-.466.54-1.048.809-1.747.809-.76 0-1.417-.292-1.971-.874-.55-.587-.824-1.35-.824-2.287 0-.977.29-1.763.87-2.36.585-.6 1.327-.9 2.228-.9.98 0 1.785.38 2.413 1.137.629.754.943 1.996.943 3.726 0 1.761-.327 3.032-.982 3.812-.655.78-1.508 1.17-2.558 1.17-.756 0-1.367-.2-1.833-.599-.466-.403-.765-1.003-.896-1.8Zm4.193-4.035c0-.596-.138-1.058-.415-1.387-.272-.328-.589-.492-.95-.492-.342 0-.628.135-.856.407-.225.267-.336.708-.336 1.32 0 .623.123 1.08.369 1.374.246.29.553.434.923.434.356 0 .655-.14.896-.42.246-.28.37-.693.37-1.236Z" }))); };
exports.default = SvgCloud9;
